/* Casucci 2026 · Pagina risultati di ricerca (sections/cs-main-search.liquid). Vanilla, nessuna dipendenza. */
(() => {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const desk = matchMedia('(min-width: 1025px)');
  const form = document.querySelector('[data-cs-sr-form]');
  const panel = document.querySelector('[data-cs-sr-panel]');
  const opener = document.querySelector('[data-cs-sr-open]');
  const scrim = document.querySelector('.cs-sr__scrim');

  const root = document.querySelector('.cs-sr');
  if (root) root.classList.add('cs-sr--js');

  if (form) {
    /* URL puliti: niente parametri prezzo vuoti */
    form.addEventListener('submit', () => {
      form.querySelectorAll('[data-cs-sr-price]').forEach((i) => { if (i.value === '') i.disabled = true; });
    });
    const send = () => (form.requestSubmit ? form.requestSubmit() : form.submit());
    let t;
    /* ponytail: invio al change solo su desktop; nel drawer mobile si conferma con "Mostra risultati" (niente ricarica a ogni tocco) */
    form.addEventListener('change', (e) => {
      if (!desk.matches) return;
      clearTimeout(t);
      t = setTimeout(send, e.target.matches('[data-cs-sr-price]') ? 700 : 0);
    });
    const sort = document.querySelector('[data-cs-sr-sort]');
    if (sort) sort.addEventListener('change', send);
  }

  if (panel && opener) {
    const focusables = () => [...panel.querySelectorAll('a[href],button,input:not([type="hidden"]):not([disabled]),select,summary')].filter((x) => x.offsetParent);
    const close = () => {
      panel.classList.remove('is-open');
      scrim.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('cs-s-lock');
      ['role', 'aria-modal', 'aria-label'].forEach((a) => panel.removeAttribute(a));
      opener.focus();
    };
    opener.addEventListener('click', () => {
      panel.classList.add('is-open');
      scrim.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('cs-s-lock');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', 'Filtri');
      (focusables()[0] || panel).focus();
    });
    document.querySelectorAll('[data-cs-sr-close]').forEach((b) => b.addEventListener('click', close));
    panel.addEventListener('keydown', (e) => {
      if (!panel.classList.contains('is-open')) return;
      if (e.key === 'Escape') return close();
      if (e.key !== 'Tab') return;
      const f = focusables(), first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* Testa della pagina: collezioni e pagine correlate + "Forse cercavi" (endpoint predictive ufficiale).
     La ricerca completa di Shopify è semantica e restituisce prodotti "simili" anche per parole senza senso:
     se il predictive non trova prodotti, avvisiamo che non c'è una corrispondenza esatta e proponiamo correzioni. */
  const rel = document.querySelector('[data-cs-sr-related]');
  const q = rel && rel.dataset.q;
  const dymBox = document.querySelector('[data-cs-dym-page]');
  const chip = (x) => {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.className = 'cs-s__chip';
    a.href = x.u || window.CsSearch.url(x.n);
    a.textContent = x.n;
    li.append(a);
    return li;
  };
  const fillDym = (extra) => {
    if (!dymBox || !window.CsSearch) return;
    const list = window.CsSearch.dym(q, extra);
    dymBox.replaceChildren(...list.map(chip));
    dymBox.closest('[data-cs-dym-wrap]').hidden = !list.length;
  };
  if (q) {
    if (!document.querySelector('[data-cs-sr-loose]')) fillDym([]);
    fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,query&resources[limit]=4')
      .then((r) => r.json())
      .then((j) => {
        const r = j.resources.results || {};
        const items = [...(r.collections || []), ...(r.pages || [])];
        if (items.length) {
          rel.querySelector('ul').replaceChildren(...items.map((x) => chip({ n: x.title, u: x.url })));
          rel.hidden = false;
        }
        const loose = document.querySelector('[data-cs-sr-loose]');
        if (loose && (r.products || []).length) return;
        fillDym((r.queries || []).map((x) => x.text));
        if (loose) loose.hidden = false;
      })
      .catch(() => {});
  }
})();
